export const useShareInSocialNetwork = () => {
  const { baseUrl } = useRuntimeConfig().public;
  const { fullPath } = useRoute();
  const getSocialShareLink = (
    socialNetwork: "X" | "LinkedIn" | "Facebook" | "WeChat"
  ): string => {
    const shareUrl = encodeURIComponent(`${baseUrl}${fullPath}`);

    switch (socialNetwork) {
      case "X":
        return `https://twitter.com/intent/tweet?url=${shareUrl}`;
      case "LinkedIn":
        return `https://www.linkedin.com/feed/?shareActive=true&shareUrl=${shareUrl}`;
      case "Facebook":
        return `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
      case "WeChat":
        return `${baseUrl}${fullPath}`;
      default:
        throw Error("Invalid social network: ", socialNetwork);
    }
  };

  return {
    getSocialShareLink
  };
};
